import React, { useEffect, useRef, useState } from "react";
import LoginComponent from '../components/login/LoginComponent';
import { Button, Col, Row } from "react-bootstrap";
import { BsChevronLeft } from "react-icons/bs";
import PassForgotForm from "../components/login/PassForgotForm";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuthState } from "../context/AuthContext";
import BasicRegForm from "../components/registration/BasicRegForm";
import Api from "../services/ApiService";
import { FaPlay } from "react-icons/fa";


const WillkommenPage = () => {

    const API = new Api();
    const { token } = useParams();
    const location = useLocation();
    const { authenticated, user } = useAuthState();
    const navigate = useNavigate();
    const [view, setView] = useState("register");
    const [videoDisplay, setVideoDisplay] = useState(require('../hero.mp4'));
    const videoRef = useRef();
    const [data, setData] = useState({
        company_type: "person",
        x_is_house_management: false,
        case: 5,
        companyKw: false,
        contactPerson: "",
        name: "",
        lastName: "",
        email: "",
        phone_country: "+43",
        vorwahl: "",
        phone: "",
        comment: "",
        situation: "Bevorstehender Umzug / Neuanmeldung",
        uploads: [],
    });

    useEffect(() => {
        if (token !== undefined && token !== "") {
            API.register_missing_document_get_user(token)
                .then(res => {
                    let resData = res.data;
                    var vorwahl = resData.phone.split(" ")[1];
                    var phone = resData.phone.split(" ")[2];
                    setData({
                        company_type: resData.is_company? 'company':'person',
                        x_is_house_management: false,
                        case: resData.change_or_new,
                        companyKw: false,
                        contactPerson: "",
                        name: resData.first_name,
                        lastName: resData.last_name,
                        email: resData.email,
                        phone_country: "+43",
                        vorwahl: vorwahl,
                        phone: phone,
                        comment: "",
                        situation: resData.situation,
                        uploads: [],
                        upload_later: token,
                    });
                    setView("register");
                })
        }
    }, [token])

    useEffect(() => {
        if (authenticated === true) {
            if (user !== null) {
                if (user.x_is_house_management) navigate('/hw/dashboard/');
                else navigate('/dashboard/');
            }
        }

    }, [authenticated])

    useEffect(() => {
        videoRef.current.load(null);
        videoRef.current.focus();
        if (videoDisplay.includes('noQrPromo')) {
            videoRef.current.muted = false; // Unmute the video
            videoRef.current.play();
        }
    }, [videoDisplay])


    return (
        <div className="parent-container">
            {videoDisplay.includes('hero')?
                <div className="video-btn-section">
                    <button
                        className="btn-energo video-btn"
                        onClick={() => setVideoDisplay(require('../noQrPromo.mp4'))}
                    >
                        <FaPlay />
                    </button>
                </div>
            :null}
            <video
                className="video-section"
                id="background-video"
                autoPlay={videoDisplay.includes('hero') ? true : false}
                muted={videoDisplay.includes('hero') ? true : false}
                controls={videoDisplay.includes('noQrPromo') ? true : false}
                ref={videoRef}
                playsInline
            >
                <source src={videoDisplay} type="video/mp4" />
            </video>
            <div className="container-section">
                {view !== 'login' ?
                    <div className="container-section-register">
                        <Col xs="12" className="text-light text-start mb-5">
                            <a onClick={e => { e.preventDefault(); setView('login') }} href="züruck/" className="link-energo-orange">
                                <BsChevronLeft size={40} /> Zurück
                            </a>
                        </Col>
                    </div>
                    : null}


                {
                    view === 'login' ?
                        <div className="container-section-login">
                            <h3 className="text-light text-start"><span className="text-dark title-energo">ENERGO</span> Managementportal</h3>
                            <Row className="mt-3 animate-slide-left">
                                <LoginComponent view={setView} />
                            </Row>
                            <Row className="mt-5">
                                <ul className="list-group list-group-flush mt-3" style={{ background: 'transparent' }}>
                                    <li className="list-group-item" style={{ backgroundColor: 'transparent' }}>
                                        <a href="/register/" onClick={e => { e.preventDefault(); setView("register") }} className="link-energo-light-bold">Kunde werden</a>
                                    </li>
                                    <li className="list-group-item" style={{ backgroundColor: 'transparent' }}>
                                        <a onClick={e => { e.preventDefault(); setVideoDisplay(require('../noQrPromo.mp4')) }} href="information/anzeigen" className="link-energo-light-bold">Vorstellungsvideo anzeigen</a>
                                    </li>
                                </ul>
                            </Row>
                        </div>

                        : view === 'pass-forgot' ?
                            <div className="container-section-login">
                                <Col xs="12" className="animate-pop text-light text-start">
                                    <h3><span className="text-dark title-energo">ENERGO - </span>Passwort anfordern / vergessen</h3>
                                    <p>Geben Sie bitte Ihre E-Mail-Adresse ein, um Ihr Passwort anzufordern/zurückzusetzen.</p>
                                </Col>
                                <Col xs="12" className="animate-slide-left mt-5">
                                    <PassForgotForm view={setView} />
                                </Col>
                            </div>

                            : view === 'pass-forgot-hv' ?
                                <div className="container-section-login text-light text-start">
                                    <Col xs="12" className="animate-pop">
                                        <h3><span className="text-dark">ENERGO - </span>HV Passwort zurückzusetzen</h3>
                                        <p className="mt-3">
                                            Zurücksetzen / Anfordern des Passworts ist für Hausverwaltungen nicht möglich.
                                            Bitte wenden Sie sich an Ihr Sekretariat, um das Passwort in Erfahrung
                                            zu bringen.
                                        </p>
                                    </Col>
                                </div>

                                : view === 'pass-forgot-done' ?
                                    <div className="container-section-login text-light text-start">
                                        <h3><span className="text-dark">ENERGO - </span>E-Mail versendet</h3>
                                        <p className="mt-3">
                                            Wir haben Ihnen eine E-Mail zukommen lassen!
                                            Folgen Sie bitte den Schritten in der E-Mail.
                                        </p>
                                    </div>

                                    : view === 'register' ?
                                        <div className="container-section-register text-start text-light">
                                            <Col className="animate-pop">
                                                <h3><span className="text-dark">ENERGO</span> - Willkommen!</h3>
                                            </Col>
                                            <BasicRegForm setView={setView} data={data} setData={setData} />
                                        </div>
                                        : null
                }
            </div>
        </div>

    )
}

export default WillkommenPage;